import { supabase } from "@/integrations/supabase/client";
import { SyncStatus } from "./types";

export class MedicalSyncService {
  // Check sync status quickly
  static async getSyncStatus(): Promise<SyncStatus[]> {
    try {
      const { data, error } = await supabase
        .from('medical_api_sync_status')
        .select('*')
        .order('updated_at', { ascending: false })
        .limit(10);

      if (error) {
        console.error('Error fetching sync status:', error);
        return [];
      }

      return data || [];
    } catch (error) {
      console.error('Error in getSyncStatus:', error);
      return [];
    }
  }

  // Trigger sync (async, non-blocking)
  static async triggerSync(apiSource: 'pubmed' | 'trip' | 'openfda' | 'dailymed' | 'clinicaltrials' | 'icd11'): Promise<boolean> {
    try {
      // Non-blocking sync trigger
      supabase.functions.invoke(`sync-${apiSource}`).catch(console.error);
      return true;
    } catch (error) {
      console.error(`Error triggering ${apiSource} sync:`, error);
      return false;
    }
  }
}